"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e={children:require("prop-types").node};exports.defaultProps={children:null},exports.propTypes=e;
